export enum OperationType {
  DELETE_INSTANCE = 'DELETE_INSTANCE',
  UPDATE_INSTANCE = 'UPDATE_INSTANCE',
  CREATE_INSTANCE = 'CREATE_INSTANCE',
}
